export enum BannerTargetEnum {
  Desktop = 1,
  Responsive = 2,
}
